export const SET_LOGGED = 'auth/set_logged'
export const LOGOUT = 'auth/logout'
